import { combineReducers } from 'redux';

import coreProductInvoice from 'app/shared/reducers/analytics/coreProductInvoice';
import propertiesReport from 'app/shared/reducers/analytics/propertiesReport';
import boostAdReport from 'app/shared/reducers/analytics/boostAdReport';
import boostAdPreviews from 'app/shared/reducers/analytics/boostAdPreviews';
import graphs from 'app/shared/reducers/analytics/graphs';
import multifamilyListings from 'app/shared/reducers/analytics/multifamilyListings';
import overviewFilter from 'app/shared/reducers/analytics/overviewFilter';
import competition from 'app/shared/reducers/analytics/competition';
import audience from 'app/shared/reducers/analytics/audience';

const rootAnalyticsReducer = combineReducers({
    coreProductInvoice,
    propertiesReport,
    boostAdReport,
    boostAdPreviews,
    graphs,
    multifamilyListings,
    overviewFilter,
    audience,
    competition,
});

export default rootAnalyticsReducer;
